import React, { useLayoutEffect } from 'react';
import { Empty as AntEmpty, Select } from 'antd';
import { useFieldController } from '../../../../../helpers/formManager';
import Field from '../../../shared/ui/Field';
import { useEvent } from '../../../../../hooks/useEvent';

const SelectIntervalTime = ({
  name,
  label,
  requiredErrMsg,
  options,
  placeholder,
  hasDuration = true,
  visible,
  onVisibleChange,
  onChange,
  hasAvailableOptions,
  allowClear,
}) => {
  const dropdownProps = {};
  setProp(dropdownProps, 'open', visible);
  setProp(dropdownProps, 'onDropdownVisibleChange', onVisibleChange);

  const { field, fieldState } = useFieldController({
    name,
    rules: { required: requiredErrMsg },
  });

  useLayoutEffect(() => {
    if (typeof onChange === 'function') {
      onChange(undefined, field.value?.context?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = useEvent((_, option) => {
    const next = option?.props?.payload ?? null;
    const current = field.value;

    field.onChange(next);

    if (typeof onChange === 'function') {
      onChange(current?.context?.id, next?.context?.id);
    }
  });

  return (
    <Field
      type={Field.types.select}
      value={field.value?.context?.id}
      onChange={handleChange}
      errorMessage={fieldState.error?.message}
      formItemLabel={label}
      required
      style={{ width: '100%' }}
      optionFilterProp="search"
      showSearch
      placeholder={placeholder}
      allowClear={allowClear}
      {...dropdownProps}
      dropdownRender={
        !hasAvailableOptions && hasDuration
          ? () => <Empty description="Нет свободного времени" />
          : undefined
      }
      notFoundContent={
        !hasDuration ? (
          <Empty description="Выберите продолжительность приемки" />
        ) : undefined
      }
    >
      {options?.map(({ option, disabled }) => (
        <Select.Option
          key={option.context.id}
          value={option.context.id}
          search={option.value}
          payload={option}
          style={disabled ? { display: 'none' } : undefined}
        >
          {option.value}
        </Select.Option>
      ))}
    </Field>
  );
};

export default SelectIntervalTime;

function Empty({ description }) {
  return (
    <AntEmpty
      style={{ whiteSpace: 'normal' }}
      image={AntEmpty.PRESENTED_IMAGE_SIMPLE}
      description={description}
    />
  );
}

function setProp(obj, propKey, propValue) {
  if (propValue !== undefined) {
    obj[propKey] = propValue;
  }
}
